import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tv-connect-capsule-wrap", { 'is-connecting': _ctx.isConnecting && !_ctx.wsConnected }]),
    "aria-label": "授课大屏连接状态"
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["tv-connect-capsule", _ctx.capsuleClass]),
      disabled: _ctx.buttonDisabled,
      "aria-live": "polite",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
    }, _toDisplayString(_ctx.buttonText), 11, _hoisted_1)
  ], 2))
}